// Ключ «тот же продукт по той же цене»: продукт с изменившейся ценой считается новым.
export function getProductKey(id: string, price: number): string {
  return `${id}_${price}`;
}
